export const SignInExceptionsErrorMessages: {
  [key in SignInErrorCodes]: {
    errorName: string;
    [detailedMessage: string]: string;
    defaultMessage: string;
  };
} = {
  NotAuthorizedException: {
    errorName: "NotAuthorizedException",
    "User is disabled.": "Benutzer ist gesperrt",
    "Incorrect username or password.": "Benutzername oder Passwort falsch",
    defaultMessage: "Benutzer ist gesperrt. Administrator kontaktieren.",
  },
  UserNotFoundException: {
    errorName: "UserNotFoundException",
    defaultMessage: "Benutzername oder Passwort falsch",
  },
  PasswordResetRequiredException: {
    errorName: "PasswordResetRequiredException",
    defaultMessage: "Sie müssen Ihr Passwort setzten!",
  },
  InvalidPasswordException: {
    errorName: "InvalidPasswordException",
    defaultMessage:
      "Das Passwort entspricht nicht den Passwortrichtlinien. Das Passwort muss mindestens 15 Zeichen haben, Zahlen, Groß-, Klein- und Spezial-Zeichen erhalten.",
  },
  UsernameExistsException: {
    errorName: "UsernameExistsException",
    defaultMessage: "Ein Account mit diesem User existiert bereits.",
  },
  UserNotConfirmedException: {
    errorName: "UserNotConfirmedException",
    defaultMessage: "Bitte bestätige die Verifizierungsmail.",
  },
};

export type SignInErrorCodes =
  | "NotAuthorizedException"
  | "UserNotFoundException"
  | "PasswordResetRequiredException"
  | "InvalidPasswordException"
  | "UsernameExistsException"
  | "UserNotConfirmedException";

export const getAuthErrorMessage = (
  code: SignInErrorCodes,
  name: string,
  message: string
) => {
  return (
    (SignInExceptionsErrorMessages[code] || {})[message] ||
    (SignInExceptionsErrorMessages[code] || { defaultMessage: "" })
      .defaultMessage
  );
};
